import { DriverRead } from 'src/common/external/bambi-api/bambiApi';
import { formatFullName } from 'src/common/util/formatFullName';

import { resolveOtherSkills } from './DriverOtherSkillKeyMap';
import { DriverProfile } from './DriverProfile';
import { resolveServiceSkills } from './DriverServiceSkillKeyMap';
import { resolveVehicleSkills } from './resolveVehicleSkills';

export function convertDriverToDriverProfile(
  driver: DriverRead
): DriverProfile {
  const first_name = driver.first_name || 'unknown';
  const last_name = driver.last_name || 'unknown';
  return {
    id: driver.id,
    firstName: first_name,
    lastName: last_name,
    name: formatFullName({ first_name, last_name }),
    memberId: driver.membership,
    organizationId: driver.organization_id,
    status: driver.can_be_scheduled,
    // TODO: usertype here?
    userType: 'associate',
    licenseNumber: driver.license_number || '',
    issuedState: driver.license_state || '',
    expirationDate: driver.license_expiration_date || '',
    dateOfBirth: driver.license_dob || '',
    vehicleSkills: resolveVehicleSkills(driver),
    serviceSkills: resolveServiceSkills(driver),
    otherSkills: resolveOtherSkills(driver),
    is_currently_clocked_in: false,
    appVersion: driver.app_version || '',
    deleted_at: driver.deleted_at,
    tags: driver.tags,
    allowed_payer_ids: driver.allowed_payers,
  };
}
